import getNameAndValueFromSlider from '../../utils/getNameAndValueFromSlider';
import getFacetsForBreadcrumbs from '../../utils/getFacetsForBreadcrumbs';

export const DDC_INVENTORY_FILTERSEARCH_CLICK =
	'ddc.inventory.filterSearch.click';

export const DDC_INCENTIVE_FILTERSEARCH = 'ddc.incentive.filterSearch';

function filterSearchClick(
	eventType = DDC_INVENTORY_FILTERSEARCH_CLICK,
	{ currentTarget: element } = {},
	_range
) {
	const checked = !!element?.checked;
	let facets = {};

	const facetContainer =
		element?.closest?.('.facetmulti, .facets-container') ||
		document.querySelector('.facetmulti');
	const getNameAndValue = (el) => ({
		name: el.getAttribute('name'),
		value: el.getAttribute('value')
	});
	const isBreadcrumb = !!element?.closest?.('.facet-breadcrumb-list');
	const isSlider = !!element?.closest?.('.facet-user-range-input-slider');

	if (facetContainer) {
		// get selected checkbox values
		const checkedInputs = facetContainer.querySelectorAll(
			'input[type="checkbox"]:checked'
		);

		for (let i = 0; i < checkedInputs.length; i++) {
			const { name, value } = getNameAndValue(checkedInputs[i]);
			facets[name] = facets[name] ? `${facets[name]},${value}` : value;
		}

		// get slider values
		const sliders = facetContainer.querySelectorAll('.facet-user-range');

		for (let i = 0; i < sliders.length; i++) {
			const { name, value, defaultValue } = getNameAndValueFromSlider(
				sliders[i]
			);

			// only apply slider value to facets if user has adjusted
			if (value !== defaultValue) {
				facets[name] = value;
			}
		}
	}

	// get name and value from checkbox
	let name = element?.getAttribute?.('name');
	let value = element?.getAttribute?.('value');

	// get name and value from slider input
	if (!name && !value) {
		const elementRange = element?.closest?.('.facet-user-range');
		if (elementRange) {
			const sliderData = getNameAndValueFromSlider(elementRange);
			name = sliderData.name;
			value = sliderData.value;
		}
	}

	facets = getFacetsForBreadcrumbs(
		isBreadcrumb,
		checked,
		facets,
		name,
		value
	);

	return {
		eventType,
		eventData: {
			element,
			checked,
			clickedFacetName: name || '',
			clickedFacetValue: value || '',
			facets,
			isBreadcrumb,
			isSlider
		}
	};
}

export default filterSearchClick;
